export const CountryEndpoints = Object.freeze({
  CountryList: '/v3/user/country'
})
